import { render, staticRenderFns } from "./Pharagraph.vue?vue&type=template&id=433d623f&"
import script from "./Pharagraph.vue?vue&type=script&lang=js&"
export * from "./Pharagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports